import script from "./resolve.vue?vue&type=script&lang=ts&setup=true"
export * from "./resolve.vue?vue&type=script&lang=ts&setup=true"

import "./resolve.vue?vue&type=style&index=0&id=6fb63fed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb63fed"]])

export default __exports__